import { Row, Col } from "react-bootstrap";
import { APP_CONFIG } from "config/appConfig";
import { ColorPicker } from "..";
import { LDSUDevice } from "./LDSUWidgetSensorList";

type LDSUWidgetActuatorListProps = {
    actuators: LDSUDevice[];
    onColorChange: (actuator: LDSUDevice, color: string) => void;
};

export const LDSUWidgetActuatorList = ({
    actuators,
    onColorChange,
}: LDSUWidgetActuatorListProps) => {
    const ldsuDisplayName = APP_CONFIG.APP_IS_ONPREM
        ? "LDSU/Auxiliary Hub"
        : "LDSU";

    if (actuators.length === 0) {
        return <></>;
    }

    return (
        <div>
            <div className="mb-2">
                {`Actuators on this ${ldsuDisplayName}`}
            </div>
            <div className="cstm-table w-100 px-2">
                <Row className="d-none d-md-flex table-head px-2">
                    <Col md={4}>Actuator</Col>
                    <Col md={4}>Type</Col>
                    <Col md={4}>Color</Col>
                </Row>

                {actuators.map((actuator, index) => (
                    <Row
                        key={`${actuator.ldsu_uuid}-${actuator.SAID}-${index}`}
                        className="bg-secondary px-2 py-3 mb-2 align-items-center rounded"
                    >
                        <Col md={4}>{actuator.device_name || "-"}</Col>
                        <Col md={4}>{actuator.sensor_type || "-"}</Col>
                        <Col md={4}>
                            <ColorPicker
                                defaultValue={actuator.color}
                                onChange={(_event: any, color: string) =>
                                    onColorChange(actuator, color)
                                }
                            />
                        </Col>
                    </Row>
                ))}
            </div>
        </div>
    );
};
